module.exports = __webpack_public_path__ + "media/images/common/apple-touch-icon-1c07ce68fc844ddfd3277fb3d1e9375f.png";